 /*
  initialize the pubads service

  With initial load disabled, calls to display() will only register the ad slot.
  No ad content will be loaded until .refresh is called on the slot.
  THIS IS LEGALLY IMPORTANT because we need cookie consent from users before
  we show any ads. See the cookie consent module for the place we actually do this.

  We set collapseEmptyDivs to prevent any ads that didn't render from staying
  open in the DOM
  */
export const setupAndEnablePubAdsService = () => {
  window.googletag.cmd.push(() => {
    window.googletag.pubads().disableInitialLoad();
    window.googletag.pubads().enableSingleRequest();
    window.googletag.pubads().collapseEmptyDivs();
    window.googletag.enableServices(); //Remember, this will not *display* ads, only get ready to after consent
  })
}
